import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";

import { useApi } from "../../../context/api.js";

function VerbSearch({ onAdd, verbs }) {
  const api = useApi();
  const timers = useRef();

  const [verbsLoading, setVerbsLoading] = useState(false);
  const [verbsChoices, setVerbsChoices] = useState([]);
  const [verbInput, setVerbInput] = React.useState("");

  const searchVerb = (event, newInputValue, reason) => {
    if (reason === "input") {
      setVerbInput(newInputValue);

      if (timers.verbSearch) {
        clearTimeout(timers.verbSearch);
      }

      if (newInputValue) {
        setVerbsLoading(true);

        timers.verbSearch = setTimeout(() => {
          api.suggestVerbs(newInputValue).then((verbs) => {
            setVerbsChoices(verbs);
            setVerbsLoading(false);
          });
        }, 500);
      } else {
        setVerbsChoices([]);
      }
    } else if (reason === "reset") {
      setVerbInput("");
    }
  };

  return (
    <Autocomplete
      disableClearable
      clearOnBlur
      //disableCloseOnSelect
      selectOnFocus
      id="verb-search"
      value={""}
      onChange={(event, newValue) => {
        onAdd(newValue);
        setVerbInput("");
      }}
      inputValue={verbInput}
      onInputChange={searchVerb}
      options={verbsChoices}
      getOptionDisabled={(v) => verbs.includes(v)}
      loading={verbsLoading}
      loadingText="Recherche..."
      noOptionsText={
        verbInput && !verbsLoading
          ? "Pas de résultat."
          : "Saisissez quelques caractères pour rechercher un verbe."
      }
      fullWidth
      sx={{ mt: 1 }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Rechercher/ajouter un verbe"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {verbsLoading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
          onKeyUp={(e) => {
            if (e.keyCode === 13 && verbInput) {
              if (verbsChoices && verbsChoices.includes(verbInput)) {
                onAdd(verbInput);
                setVerbsChoices([]);
                setVerbInput("");
              }
            }
          }}
        />
      )}
    />
  );
}

VerbSearch.propTypes = {
  onAdd: PropTypes.func.isRequired,
  verbs: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default VerbSearch;
